import React from 'react';
import { Box } from '@mui/material';

export default function Loading() {
    return (
        <Box
            sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
            }}
        >
            <Box sx={{ display: 'flex', gap: '8px' }}>
                {[...Array(3)].map((_, i) => (
                    <Box
                        key={i}
                        sx={{
                            width: '18px',
                            height: '18px',
                            borderRadius: '50%',
                            backgroundColor: '#1976d2',
                            animation: `bounce 1.0s infinite ${i * 0.2}s ease-in-out`,
                        }}
                    />
                ))}
            </Box>
            <style>
                {`
                        @keyframes bounce {
                        0%, 80%, 100% { transform: translateY(0); }
                        40% { transform: translateY(-10px); }
                        }
                    `}
            </style>
        </Box>
    );
}
